module.exports = __webpack_public_path__ + "static/media/About me image.1b959949.jpeg";